module.exports = __webpack_public_path__ + "img/subscriptions.ced02e70.png";